module.exports = __webpack_public_path__ + "img/sticky.654360e9.svg";